import React, { useEffect } from 'react'

// Components

import SectionHeading from '../../../../UI/SectionHeading/SectionHeading';
import RadioInput from '../../../../UI/FormInput/RadioInput';
import Button from '../../../../UI/Button/Button';
import JobAddressFields from '../JobAddressFields';
import Employee from '../JobTypeFields/Employee';
import Income from '../JobTypeFields/Income';
import Business from '../JobTypeFields/Business';
import Alert from '../../../../UI/Alert/Alert';
import { ACCOUNT_PRODUCT_NAMES } from '../../../../../config/constants';

export default function JobInformation({ formik, goToPreviousModule }) {

    useEffect(() => {
        const tipoCliente = formik.values?.cliente?.tipoCliente;
        const isValidClientType = ['1', '2', '3', '4'].includes(tipoCliente);
        const isTypeTwo = tipoCliente === '2';
        const isTypeOne = tipoCliente === '1';

        const hasLevelOneAccount = formik.values?.selectedProducts?.some(
            item => item.label === ACCOUNT_PRODUCT_NAMES.currentLevelOneAccount
        );

        formik.setFieldValue('jobReferences.tipoCliente', tipoCliente);

        if (!isValidClientType) {
            formik.setFieldValue('jobReferences.hasJob', 'no');
            formik.setFieldValue('jobReferences.hasIncome', 'no');
            formik.setFieldValue('jobReferences.hasBusiness', 'no');

            return;
        }

        if (isTypeTwo) {
            formik.setFieldValue('jobReferences.hasJob', 'no');
        }

        if (isTypeTwo && hasLevelOneAccount) {
            formik.setFieldValue('jobReferences.hasLevelOneAccount', 'si');
            formik.setFieldValue('jobReferences.hasIncome', 'si');
            formik.setFieldValue('jobReferences.hasBusiness', 'no');
        } else if (isTypeOne && hasLevelOneAccount) {
            formik.setFieldValue('jobReferences.hasLevelOneAccount', 'si');
            formik.setFieldValue('jobReferences.hasBusiness', 'no');
        } else {
            formik.setFieldValue('jobReferences.hasLevelOneAccount', 'no');
        }
    }, []);

    return (
        <>
            <SectionHeading text={'Información Laboral'} />
            {['1', '2', '3', '4'].includes(formik.values?.cliente?.tipoCliente) &&
                <>
                    {/* Employee Job Fields ================================================================================================================= */}

                    <h3 className="multiple-input-heading">Empleo</h3>

                    <RadioInput
                        formik={formik}
                        fieldName={'jobReferences.hasJob'}
                        label={'¿Posee Empleo?'}
                        options={[{ label: 'Sí', value: 'si' }, { label: 'No', value: 'no' },]}
                        isGroup={true}
                        isRequired={true}
                        disabled={['2'].includes(formik.values?.cliente?.tipoCliente)}
                    />

                    {formik.values?.jobReferences?.hasJob === 'si' &&
                        <div>


                            <SectionHeading text={'Dirección de Empleo'} isSubHeading />

                            {/* Job Address Fields */}

                            <JobAddressFields
                                formik={formik}
                                index={'empleo'}
                            />

                            <SectionHeading text={'Datos Empleo'} isSubHeading />

                            <Employee
                                formik={formik}
                            />

                        </div>}


                    {/* Income Job Fields ================================================================================================================= */}

                    <h3 className="multiple-input-heading">Otro tipo de Ingreso</h3>

                    {formik.values?.cliente?.tipoCliente === '2' && formik.values?.jobReferences?.hasLevelOneAccount === 'si' &&
                        <Alert text={<strong>Para la apertura de su Cuenta Corriente Nivel 1, es necesario que introduzca un ingreso</strong>} />
                    }

                    <RadioInput
                        formik={formik}
                        fieldName={'jobReferences.hasIncome'}
                        label={'¿Posee Ingreso?'}
                        options={[{ label: 'Sí', value: 'si' }, { label: 'No', value: 'no' },]}
                        isGroup={true}
                        isRequired={true}
                        disabled={formik.values?.cliente?.tipoCliente === '2' && formik.values?.jobReferences?.hasLevelOneAccount === 'si'}
                    />

                    {formik.values?.jobReferences?.hasIncome === 'si' &&
                        <div>

                            <SectionHeading text={'Dirección de Ingreso'} isSubHeading />

                            {/* Job Address Fields */}

                            <JobAddressFields
                                formik={formik}
                                index={'ingreso'}
                            />

                            <SectionHeading text={'Datos Ingreso'} isSubHeading />

                            <Income
                                formik={formik}
                            />

                        </div>}


                    {/* Business Job Fields ================================================================================================================= */}

                    <h3 className="multiple-input-heading">Negocio Propio</h3>

                    <RadioInput
                        formik={formik}
                        fieldName={'jobReferences.hasBusiness'}
                        label={'¿Posee Negocio Propio?'}
                        options={[{ label: 'Sí', value: 'si' }, { label: 'No', value: 'no' },]}
                        isGroup={true}
                        isRequired={true}
                        disabled={(formik.values?.cliente?.tipoCliente === '1' || formik.values?.cliente?.tipoCliente === '2') && formik.values?.jobReferences?.hasLevelOneAccount === 'si'}
                    />

                    {formik.values?.jobReferences?.hasBusiness === 'si' &&
                        <div>


                            <SectionHeading text={'Dirección de Negocio Propio'} isSubHeading />

                            {/* Job Address Fields */}

                            <JobAddressFields
                                formik={formik}
                                index={'negocioPropio'}
                            />

                            <SectionHeading text={'Datos Negocio Propio'} isSubHeading />

                            <Business
                                formik={formik}
                            />

                        </div>}
                </>}

            {!['1', '2', '3', '4'].includes(formik.values?.cliente?.tipoCliente) &&
                <Alert text={'Puedes continuar'} />
            }

            <div className='form-actions'>

                <Button
                    action={() => goToPreviousModule(1)}
                    label={'Regresa'}
                    secondaryStyle={true}
                />

                <Button
                    type="submit"
                    action={formik.handleSubmit}
                    label={'Continua'}
                />

            </div>
        </>
    )
}
